import { useEffect, useState } from 'react';
import { useSubmit } from 'react-router';

export const useClearableField = (name: string, initialValue: string) => {
  const [value, setValue] = useState(initialValue);
  const submit = useSubmit();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleClear = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // clear it in state
    setValue('');

    // submit form without the cleared field
    const form = e.currentTarget.form;
    if (form) {
      const formData = new FormData(form);
      formData.delete(name);
      submit(formData);
    }
  };

  return {
    inputProps: {
      name,
      value,
      onChange: (e: React.ChangeEvent<HTMLInputElement> | string) => {
        if (typeof e === 'string') {
          setValue(e);
          return;
        }

        setValue(e.target.value);
      },
    },
    showClearButton: initialValue !== '',
    clearButtonProps: {
      onClick: handleClear,
    },
    clearWithoutSubmit: () => setValue(''),
  };
};
